import { render, staticRenderFns } from "./disperindag_perluasan.vue?vue&type=template&id=5dbb2ac1&"
import script from "./disperindag_perluasan.vue?vue&type=script&lang=js&"
export * from "./disperindag_perluasan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QSelect,QInput,QBtn,QTooltip,QSeparator,QBtnGroup,QDialog,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QSelect,QInput,QBtn,QTooltip,QSeparator,QBtnGroup,QDialog,QCardActions})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
